const createNetworkMonitor = () => {
    const listeners = new Set();
    let intervalId = null;

    const checkConnection = () => navigator.onLine;

    const startMonitoring = () => {
        if (!intervalId) {
            intervalId = setInterval(() => {
                if (checkConnection()) {
                    listeners.forEach((listener) => listener());
                    listeners.clear();
                    clearInterval(intervalId);
                    intervalId = null;
                }
            }, 1500);
        }
    };

    const waitForNetwork = () => {
        return new Promise((resolve) => {
            if (checkConnection()) {
                resolve();
                return;
            }

            listeners.add(resolve);
            startMonitoring();
        });
    };

    return { checkConnection, waitForNetwork };
};

const networkMonitor = createNetworkMonitor();

export const withRetryNetworkRequest = async (apiFunction) => {
    const executeRequest = async () => {
        try {
            return await apiFunction();
        } catch (error) {
            if (!networkMonitor.checkConnection()) {
                await networkMonitor.waitForNetwork();
                return executeRequest();
            }
            throw error;
        }
    };

    return executeRequest();
};
